/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetingType } from '../../models/meeting-type';

export interface GetAllMeetingTypes$Plain$Params {
}

export function getAllMeetingTypes$Plain(http: HttpClient, rootUrl: string, params?: GetAllMeetingTypes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MeetingType>>> {
  const rb = new RequestBuilder(rootUrl, getAllMeetingTypes$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MeetingType>>;
    })
  );
}

getAllMeetingTypes$Plain.PATH = '/api/MeetingType';
